export const ACTION_SAVE_UTILS_PAGINATED = 'ACTION_SAVE_UTILS_PAGINATED';
export const ACTION_SAVE_UTILS_DETAILS = 'ACTION_SAVE_UTILS_DETAILS';
export const ACTION_CLEAN_UTILS = 'CLEAN_UTILS';
